import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { isEmail, extractEmail } from '@app/shared/helpers/validators';

@Component({
  selector: 'app-smash-input-tag',
  templateUrl: './smash-input-tag.component.html',
  styleUrls: ['./smash-input-tag.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmashInputTagComponent),
      multi: true
    },
  ]
})
export class SmashInputTagComponent implements OnInit {

  constructor() { }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
  }

  @Input() placeholder: string;
  @Input() icon: string;
  @Input() toggled: boolean;
  @Input() disabled = false;
  @Input() error: boolean;
  @Input() suggestList: any[];
  @Input() _value: any;
  @Input() autocapitalize = 'none';

  @Output() updateTagList: EventEmitter<any> = new EventEmitter();
  @Output() updateSuggestList: EventEmitter<any> = new EventEmitter();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('searchElement') searchElement: ElementRef;

  parsedValue: any[];
  contactsExpanded = false;
  contactCount = 0;
  tagList: any;
  focused = false;
  showSuggest = false;
  suggestListBuffer: any[];
  tagValue: string;
  splitPattern = new RegExp('[\,|\;| *]');


  private wasInside = false;
  output = [];

  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.showSuggest = false;
    }
    this.wasInside = false;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value.join(';');
      this.processInput({});
    } else {
      this.value = null;
    }
  }

  ngOnInit() {
    this.value = '';
    this.parsedValue = [];
    this.tagList = [];
    this.suggestListBuffer = this.suggestList;
  }

  hideSuggest() {
    this.showSuggest = false;
  }

  autoSuggest(event) {
    if (event.target.value === '') {
      this.showSuggest = false;
      event.stopPropagation();
      return false;
    }
    // remove already added emails from the suggestBuff
    if (this.tagList.length) {
      this.suggestListBuffer = this.suggestList.filter((input) => this.tagList.indexOf(input) === -1); // remove already added tags
    } else {
      this.suggestListBuffer = this.suggestList; // start with what we have
    }

    // keep only tags that match the search
    const inputValue = event.target.value;
    const inputs = this.suggestListBuffer.filter(tag => tag.indexOf(inputValue) > -1); // filter suggest
    this.suggestListBuffer = inputs.filter((input, i) => inputs.indexOf(input) === i).sort(); // no duplicates

    // keep the suggest open if any other suggest in the list
    this.showSuggest = !!this.suggestListBuffer.length;
  }

  processInput(event) {
    if (event.stopPropagation) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.parsedValue = this.value
      .split(this.splitPattern)
      .filter(i => i !== '')
      .map(val => extractEmail(val))
      .filter(input => isEmail(input))
      .map(v => v.toLowerCase());

    const inputs = [...this.tagList, ...this.parsedValue];
    this.tagList = inputs.filter((input, i) => inputs.indexOf(input) === i); // no duplicates
    this.contactCount = this.tagList.length;
    const mainDiv = document.getElementById('mainDiv'); // loocated in email form component
    const that = this;
    setTimeout(() => {
      const move = (31 * that.contactCount) - 88;
      mainDiv.scrollTop = move;  // to continue ...;
    }, 500);
    this.onChange(this.tagList);
    this.updateTagList.emit(this.tagList); // add emails to user contacts
    this.value = '';
  }

  deleteItem(item) {
    this.tagList = this.tagList.filter(tag => tag !== item);
    this.contactCount = this.tagList.length;
    this.suggestListBuffer = [...this.suggestListBuffer, item].sort(); // add the item back to suggest list
    this.onChange(this.tagList);
  }

  deleteSuggestion(event, suggest) {
    event.stopPropagation();
    this.suggestListBuffer = this.suggestListBuffer.filter(tag => tag !== suggest);
    this.showSuggest = !!this.suggestListBuffer.length;

    this.suggestList = this.suggestList.filter(tag => tag !== suggest);
    this.updateSuggestList.emit(this.suggestList);
  }

  onChange: any = () => { };
  onTouch: any = () => { };

  // writeValue(tagList: any) { }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  addTag(event, suggest) {
    this.value = suggest;
    const inputs = this.suggestListBuffer.filter(email => email !== suggest); // remove added from suggest
    this.suggestListBuffer = inputs.filter((input, i) => inputs.indexOf(input) === i); // no duplicates
    this.processInput(event);
    this.showSuggest = !!this.suggestListBuffer.length;
    this.searchElement.nativeElement.focus();
  }

  onFocus() {
    this.focused = true;
  }

  onFocusOut() {
    this.focused = false;
  }
}
